export const MaxNodeNameLength = 500 as const;
